<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <div class="md-layout-item md-size-50 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              교우회 통계
            </h4>
          </md-card-header>
          <md-card-content>
            <div style="display:flex; flex-flow: column; font-size: 1.17em; font-weight: bold;">
              <span>총 교우 : <span style="color:darkcyan">{{ formatter.getCurrency(statisticsList[0].val) }} 명</span></span>
              <br/>
              <span>주소 보유 교우 : <span style="color:darkcyan">{{ formatter.getCurrency(statisticsList[1].val) }} 명</span></span>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-50 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              교우 회비 통계
            </h4>
          </md-card-header>
          <md-card-content>
            <div style="display:flex; flex-flow: column; font-size: 1.17em; font-weight: bold;">
              <span>금일 : <span style="color:darkcyan">{{ formatter.getCurrency(statisticsList[2].val) }} 원</span></span>
              <br/>
              <span>1.1 ~ 현재 : <span style="color:darkcyan">{{ formatter.getCurrency(statisticsList[3].val) }} 원</span></span>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-50 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              홈페이지 통계
            </h4>
          </md-card-header>
          <md-card-content>
            <div style="display:flex; flex-flow: column; font-size: 1.17em; font-weight: bold;">
              <span>홈페이지 가입자 : <span style="color:darkcyan">{{ formatter.getCurrency(statisticsList[4].val) }} 명</span></span>
              <br/>
              <span>금일 방문자 : <span style="color:darkcyan">{{ formatter.getCurrency(statisticsList[5].val) }} 명</span></span>
            </div>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-50 no-padding">
        <md-card>
          <md-card-header md-alignment="space-between">
            <h4 class="title">
              <md-icon>receipt_long</md-icon>
              교우회 행사
            </h4>
          </md-card-header>
          <md-card-content>
            <div v-if="eventList.length != 0" v-for="item in eventList" :key="item.event_title" style="display:flex; flex-flow: column; font-size: 1.17em; font-weight: bold;">
              <span>행사명 : <span style="color:darkcyan">{{ item.eventTitle }}</span></span>
              <br/>
              <span>행사 참석자 : <span style="color:darkcyan">{{ item.cnt == null? 0: formatter.getCurrency(item.cnt) }} 명</span></span>
            </div>
            <div v-if="eventList.length == 0" style="display:flex; flex-flow: column; font-size: 1.17em; font-weight: bold;">
              <span>행사명 : <span style="color:darkcyan"> 행사 없슴 </span></span>
              <br/>
              <span>행사 참석자 : <span style="color:darkcyan"> 0 명</span></span>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <div class="md-layout">
      <!-- 목록 시작 -->
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>list</md-icon>
            공지사항
          </h4>
        </md-card-header>
        <md-card-content>
          <grid ref="boardGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @dblclick="onDblClickExecutive"
                @response="response"
          ></grid>
        </md-card-content>
      </md-card>
    </div>

    <modal v-if="isShowBoardModal" class="search-friend-modal">
      <template slot="header">
        <h4 class="modal-title">게시글 상세</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="() => {this.isShowBoardModal = false}">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <template slot="body">
        <div class="md-layout">
          <table class="flex-table">
            <tr>
              <th star>제목</th>
              <td colspan="7"><input type="text" v-model="boardData.subject"></td>
            </tr>
            <tr>
              <th star>내용</th>
              <td colspan="7">
                <!-- initialEditType="wysiwyg"   "markdown" -->
                <Editor ref="toastuiEditor" v-if="boardData.content != null"
                        initialEditType="wysiwyg"
                        previewStyle="tab"
                        height="400px"
                        minHeight="300px"
                        language="ko-KR"
                        useCommandShortcut=true
                        useDefaultHTMLSanitizer=true
                        usageStatistics=false
                        hideModeSwitch=true
                        placeholder="내용을 입력 하세요"
                        :initialValue="this.boardData.content"
                        @load="onEditorLoad"
                        @focus="onEditorFocus"
                        @blur="onEditorBlur"
                        @change="onEditorChange"
                        @stateChange="onEditorStateChange"
                />
              </td>
            <tr>
              <th>첨부파일</th>
              <td colspan="7">
                <div class="inline-flex">
                  <input type="text" v-model="savedFileName" disabled/>
                  <span type="button" @click="onClickDownLoad" style="cursor: pointer;" :disabled="savedFileName == null || savedFileName == ''">
            				<md-icon>download</md-icon>다운로드
            			</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {Modal} from "@/components";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import {Grid} from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import "codemirror/lib/codemirror.css";
import "@toast-ui/editor/dist/toastui-editor.css";
import {Editor} from "@toast-ui/vue-editor";
import session from "@/kuaa/kuaa-sessions";
import formatter from "@/kuaa/kuaa-formatter";

export default {
  name: "KuaaDashboard",

  components: {
    Modal,
    grid: Grid,
    Editor
  },
  created() {
    this.getDashbordInfo();
    this.initGrid();
  },
  computed: {
  },
  data() {
    return {
      formatter,
      userNo: session.get("userNo"),
      isShowBoardModal: false,
      attchFile: null,
      savedImgUrl: "",
      savedFileBaseId: "",
      savedFileName: "",

      boardData: {
        boardCtgCd: null,
        boardId: null,
        uprBoardId: null,
        subject: null,
        content: null,
        fileName: null,
        insertUserNo: null,
        insertDate: null,
        updateUserNo: null,
        updateDate: null,
        boardStartDt: null,
        boardEndDt: null
      },

      dataSource: {
        withCredentials: false,
        initialRequest: true,
        api: {
          readData: { 
            contentType: 'application/json'
            , url: URL_CONST.GET_BOARD_LIST
            , method: 'POST'
            , initParams: {perPage: 20,page: 1} }
        },
        headers: { 'X-Auth-Token': session.get('token') }
      },

      statisticsList: null,
      eventList: null

    };
  },

  methods: {
    newBoard() {
      this.isEdit = false;
      this.savedFileName = null;
      this.attchFile = null;
      this.savedImgUrl = "";
      this.savedFileBaseId = "";
      this.boardData = {
        boardCtgCd: 'PUB',
        boardId: null,
        uprBoardId: null,
        subject: null,
        content: "",
        fileName: null,
        boardStartDt: null,
        boardEndDt: null,
        insertUserNo: null
      };
      this.isShowBoardModal = true;
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(null, true, null);
      this.gridProps['el'] = this.$refs.boardGrid;
      this.gridProps['data'] = this.dataSource;
      this.gridProps['columns'] = [
        {header: '게시판ID', name: 'boardId', hidden:true},
        {header: '제목', name: 'subject'},
        {header: '작성자', name: 'insertUserNo', align: 'center'},
        {header: '작성일시', name: 'insertDate', align: 'center'},
        {header: '변경자', name: 'updateUserNo', align: 'center'},
        {header: '변경일시', name: 'updateDate', align: 'center'},
        {header: '파일첨부', name: 'isFileAttch', align: 'center'},
        {header: '', name: 'boardCtgCd', hidden: true},
        {header: '', name: 'uprBoardId', hidden: true},
        {header: '', name: 'readCnt', hidden: true},
        {header: '', name: 'boardStartDt', hidden: true},
        {header: '', name: 'boardEndDt', hidden: true}
      ];
      this.gridProps['options'].bodyHeight = 400;
      this.gridProps['pagination'] = {
        perPage: 20
      };
    },
    response(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if (res.result) {
        //this.pagination.total = res.data.pagination.totalCount;
        //this.gridProps['options'].pageOptions = null;
      } else {
        kuaaFnc.showSwal("Dashboard", res.resultMessage);
      }
    },
    onDblClickExecutive(e) {
      if (e.instance.getRow(e.rowKey) != null) {
        this.isEdit = true;
        this.isShowBoardModal = true;
        this.boardData = e.instance.getRow(e.rowKey);
        this.savedFileName = this.boardData.orgFileNm;
        this.savedImgUrl = this.boardData.file;
        this.savedFileBaseId = this.boardData.fileBaseId;
        this.boardData.fileName = null;
      }
    },
    onClickSearchFile(event) {
      let input = document.getElementById("boardFileInput");
      input.onchange = e => {
        let file = e.target.files[0];
        this.boardData.fileName = file.name;
        this.attchFile = file;
      };

      input.click();
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    onClickDownLoad() {
      if(!this.savedFileName) return false;
      location.href = URL_CONST.FILE_DOWN_LOAD + '?fileBaseId=' + this.boardData.fileBaseId;
    },
    savePhoto(data) {
      if (this.boardData.fileName != null) {
        let formData = new FormData();
        formData.append("uploadFiles", this.attchFile);
        formData.append("fileCtgCd", "BOARD");
        formData.append("fileBizId", data.boardCtgCd + data.boardId);

        kuaaApi.sendServerMixData(
            URL_CONST.FILE_UPLOAD,
            formData,
            "post",
            res => {
              if (res.data.success) {
                if (res.data.data[0].fileBaseId) {
                  this.savedImgUrl = URL_CONST.FILE_DOWN_LOAD + '?fileBaseId=' + res.data.data[0].fileBaseId;
                  this.savedFileBaseId = res.data.data[0].fileBaseId;
                  kuaaFnc.showSwal("게시판 저장", '저장 되었습니다.');
                  this.$refs.boardGrid.invoke("readData", 1, null);
                }
              } else {

              }
            }
        );
      }
    },

    scroll() {
      this.$refs.toastuiEditor.invoke('scrollTop', 10);
    },
    moveTop() {
      this.$refs.toastuiEditor.invoke('moveCursorToStart');
    },
    getHtml() {
      let html = this.$refs.toastuiEditor.invoke('getHtml');
    },

    onEditorLoad() {
      // implement your code
    },
    onEditorFocus() {
      // implement your code
    },
    onEditorBlur() {
      // implement your code
    },
    onEditorChange() {
      // implement your code
    },
    onEditorStateChange() {
      // implement your code
    },

    getDashbordInfo(){
      kuaaApi.sendServer(
          URL_CONST.GET_DASHBOARD_STATISTICS_INFO,
          {},
          "post",
          response => {
            console.log(response);
            if (response.data.result) {
              this.statisticsList = response.data.data.contents.statisticsList;
              this.eventList = response.data.data.contents.eventList;

            } else {
              kuaaFnc.showSwal("Dashboard data error", response.data.resultMessage);
            }
          }
      );

    }

  }
};
</script>

<style scoped>
tr.md-table-row {
  cursor: pointer;
}
</style>